import * as React from 'react';

function SvgLogoWithText(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 108 43"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			{...props}
		>
			<defs>
				<path id="logo-with-text_svg__a" d="M0 .136h42.03v42.397H0z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<g transform="translate(0 -.169)">
					<mask id="logo-with-text_svg__b" fill="#fff">
						<use xlinkHref="#logo-with-text_svg__a" />
					</mask>
					<path
						d="M21.015.136C9.41.136 0 9.627 0 21.334c0 11.708 9.41 21.199 21.015 21.199 11.607 0 21.016-9.491 21.016-21.199 0-1.029-.073-2.04-.213-3.03C40.36 8.032 31.602.136 21.015.136"
						fill="#000"
						mask="url(#logo-with-text_svg__b)"
					/>
				</g>
				<path
					d="M30.443 10.121c.545.474 1.053.988 1.52 1.537l-4.84 4.882a7.718 7.718 0 00-1.522-1.535l4.842-4.884z"
					fill="#FDCB64"
				/>
				<path
					d="M19.94 10.408V6.633a14.41 14.41 0 012.088-.005l.064.006v6.905a7.637 7.637 0 00-1.077-.085c-.366 0-.723.035-1.075.085v-3.13z"
					fill="#ACCC57"
				/>
				<path d="M21.036 22.721l-10.97-11.065c.47-.55.98-1.06 1.523-1.533l10.968 11.064-1.52 1.534z" fill="#44B388" />
				<path
					d="M30.49 32.168c-.015.014-.032.027-.048.04l-4.841-4.882c.285-.216.561-.446.821-.707.259-.262.487-.54.7-.828l4.842 4.884a14.572 14.572 0 01-1.473 1.493"
					fill="#E6127A"
				/>
				<path
					d="M35.428 22.187c-.001.022-.005.043-.006.064h-6.845a7.84 7.84 0 00.084-1.086c0-.369-.035-.73-.084-1.084h6.846c.05.691.055 1.394.005 2.106"
					fill="#F18B6E"
				/>
				<path fill="#000" d="M58.663 12.087H43.965v3.218h5.407V30.74h3.87V15.305h5.421z" />
				<path
					d="M63.793 27.675h-.077l-3.05-11.168h-4.101l4.947 14.322-.128.543c-.295 1.138-1.103 1.63-2.5 1.63-.153 0-.717-.014-.845-.04v2.922c.14.025 1.282.051 1.422.051 3.524 0 5.254-1.28 6.458-4.912l4.883-14.516h-3.947l-3.062 11.168zM87.983 16.3c-2.05 0-3.742 1.125-4.382 2.909h-.077c-.474-1.862-1.91-2.908-3.934-2.908-1.884 0-3.422 1.073-4.024 2.792h-.077v-2.586h-3.613V30.74h3.742v-8.557c0-1.616 1.024-2.753 2.498-2.753 1.448 0 2.32.917 2.32 2.442v8.868h3.613V22.13c0-1.616.987-2.701 2.46-2.701 1.525 0 2.359.917 2.359 2.585v8.725h3.741V21.07c0-2.87-1.857-4.77-4.626-4.77M100.74 19.08c1.735 0 2.944 1.215 3.008 3.076H97.64c.129-1.822 1.39-3.076 3.1-3.076zm6.633 5.415v-1.163c0-4.33-2.596-7.07-6.672-7.07-4.153 0-6.802 2.895-6.802 7.42 0 4.523 2.636 7.303 6.943 7.303 3.446 0 6.005-1.836 6.416-4.59h-3.459c-.36 1.1-1.478 1.772-2.893 1.772-1.98 0-3.304-1.384-3.304-3.438v-.234h9.771z"
					fill="#000"
				/>
			</g>
		</svg>
	);
}

export default SvgLogoWithText;
